module.exports = __webpack_public_path__ + "img/schedule-service-bar-honda.f4a1cd79.png";